export default __webpack_public_path__ + "static/media/esriLogo.613ab67d.png";